import { z } from 'zod';

import { ErrorResponse } from './common.js';

export const omniAccountsItem = z.object({
  id: z.string(),
  name: z.string(),
  companyId: z.number(),
  externalAccountId: z.string(),
  externalAccountName: z.string(),
  currency: z.string(),
  platform: z.string(),
  expired: z.boolean(),
  usingInCampaigns: z.boolean(),
  amazonRegion: z.string().nullable(),
  userUpdatedAt: z.string().nullable().optional(),
  connectedAt: z.string().optional(),
  connectedByUserId: z.string().optional(),
  connectedBy: z.string().optional(),
  userUpdatedId: z.string().or(z.number()).nullable().optional(),
});

export const OmniBasicBodySchema = z.object({
  integrationName: z.string().nullable().optional(),
  platform: z.string().nullable(),
  integrationId: z.string().optional(),
  connectionName: z.string().nullable().optional(),
  connectionId: z.string().optional(),
  credentials: z.object({
    username: z.string().nullable(),
    password: z.string().nullable(),
    clientSecret: z.string().optional(),
    clientId: z.string().optional(),
  }),
});

export const OmniBasicResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        state: z.string().optional(),
        connectionId: z.string().optional(),
      }),
    ),
  }),
  error: ErrorResponse.optional(),
});

export const OmniBasicReconnectResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        integrationId: z.number().optional(),
        connectionId: z.string().optional(),
      }),
    ),
  }),
});

export const OmniTradeDeskBodySchema = z.object({
  integrationName: z.string().nullable().optional(),
  platform: z.string().nullable(),
  integrationId: z.number().optional(),
  partnerId: z.string().optional(),
  connectionId: z.number().optional(),
  connectionName: z.string().nullable().optional(),
  credentials: z.object({
    username: z.string().nullable(),
    password: z.string().nullable(),
  }),
});
